import React from 'react'
import { DateRangePicker as DRPicker, DateRangePickerShape } from 'react-dates'
import { DatepickerAdvancedWrapper } from './style'

const DateRangePicker: React.FC<DateRangePickerShape> = (props) => (
  <DatepickerAdvancedWrapper>
    <DRPicker {...props} />
  </DatepickerAdvancedWrapper>
)

export default DateRangePicker
